export const colors = {
    green: 'rgba(200, 255, 200, 1)',
    darkGreen: 'rgba(0, 175, 0, 1)',
  };